const LogoutIcon = (
  <svg
    width="20"
    height="25"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="translate(1.4066 1.4066) scale(2.81 2.81)"
      fill="none"
      stroke="none"
      strokeWidth="0"
      strokeDasharray="none"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit="10"
      fillRule="nonzero"
      opacity="1"
    >
      <path
        d="M69.313 54.442c-.397 0-.798-.118-1.147-.363-.904-.636-1.122-1.883-.487-2.786l10.118-14.399L67.679 22.495c-.635-.904-.417-2.151.487-2.786.904-.637 2.151-.417 2.786.486l10.926 15.549c.484.69.484 1.61 0 2.3L70.952 53.592c-.389.554-1.009.85-1.639.85z"
        fill="#ffffff"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M57.693 30.092c1.104 0 2-.896 2-2V2c0-1.104-.896-2-2-2H9.759c-.013 0-.024.003-.037.004a.783.783 0 0 0-.141.011c-.122.009-.24.027-.354.057a2.393 2.393 0 0 0-.487.142c-.113.038-.221.085-.324.142a.603.603 0 0 0-.031.017.737.737 0 0 0-.031.025 3.07 3.07 0 0 0-.36.287c-.012.012-.026.035-.044.054a3.21 3.21 0 0 0-.228.307 2.663 2.663 0 0 0-.216.382 3.27 3.27 0 0 0-.13.316 2.5 2.5 0 0 0-.138.41 2.307 2.307 0 0 0-.038.125 2.394 2.394 0 0 0-.061.336V71.787c0 .17.028.333.068.49.011.043.025.083.039.124.04.123.091.239.152.35.019.033.034.068.054.1a2.487 2.487 0 0 0 .3.371c.022.021.047.037.07.058.102.09.214.169.333.237.021.012.037.03.058.042L40.775 90a2.002 2.002 0 0 0 1.036-.289c.598-.362.964-1.012.964-1.711V73.787h14.918c1.104 0 2-.896 2-2V45c0-1.104-.896-2-2-2s-2 .896-2 2v24.787H42.775V18.213a2 2 0 0 0-1.074-1.772L17.902 4h37.791v24.092c0 1.104.896 2 2 2z"
        fill="#ffffff"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M80.241 38.894H47.536c-1.104 0-2-.896-2-2s.896-2 2-2h32.705c1.104 0 2 .896 2 2s-.896 2-2 2z"
        fill="#ffffff"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default LogoutIcon;
